<template>
    <div class="settingModule">
        <label for="resultNo">Number of results</label>
        <input type="number" name="resultNo" id="resultNo" v-model="settingsModule.default"><br>
        <em>How many results should the widget show and load as default</em>
        <transition name="slide-fade" :duration="{ enter: 500, leave: 0 }">
            <div>
                <hr>
                <div v-for="(tagGroup, index) in tags" :key="index">
                    <p class="tagGroupName">{{tagGroup.tagGroup}}</p>
                    <div v-for="(tag, index) in tagGroup.tags" :key="index">
                        <label class="container"> {{tag.name}}
                                                <input type="radio" name="tag" :checked="tag.active" v-on:click="pickedTag = tag.tagId" :data-prefix="tag.active">
                                                <span class="checkmark"></span>
                                            </label>
                    </div>
                </div>
                <em>Pick a section to show news from</em>
            </div>
        </transition>
        <button :disabled="settingsModule.resultNo <= 0 || settingsModule.resultNo == '' || this.$parent.saving || (pickedTag == '' && settingsModule.mode == 'articles')" class="saveRelationsBtn" @click="saveSettings"><font-awesome-icon  :icon="['fas', saving ? 'spinner' : 'save']" :spin="saving ? true : false" /> Save</button>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        props: ["contentid", "settings", "saving"],
        components: {},
        data() {
            return {
                settingsModule: '',
                tags: [],
                pickedTag: '',
                categoriesAllowed: []
            }
        },
        mounted() {
            this.getSettings();
        },
        computed: {
            activeTags: function() {
                var tempActiveTags = [];
                this.tags.forEach(group => {
                    group.tags.forEach(tag => {
                        if (tag.active) {
                            tempActiveTags.push(tag.tagId)
                        }
                    })
                })
                return tempActiveTags;
            },
        },
        methods: {
            getTags: function() {
                axios.get(basedir + "/ajaxRequestServlet?mode=NewsTags").then(response => {
                    response.data.tagGroups.forEach(tagGroup => {
                        tagGroup.tags.forEach(tag => {
                            if (tag.tagId == this.settingsModule.idForSection) {
                                this.pickedTag = this.settingsModule.idForSection
                                tag["active"] = true;
                            } else {
                                tag["active"] = false;
                            }
                        })
                    })
                    this.tags = response.data.tagGroups
                })
            },
            getSettings: function() {
                var tempArraySettings = [];
                var settingsObj = new Object();
                settingsObj["WCMS_WebPageContent_ID"] = this.contentid;
                tempArraySettings.push(settingsObj)
                axios.get(basedir + '/ajaxRequestServlet?mode=WebContentElement&WCMS_WebPageContent_ID=' + this.contentid).then(response => {
                    this.settingsModule = response.data.AdditionalContentAttributes == "" ? {
                        "idForSection": 0,
                        "default": 5,
                    } : JSON.parse(response.data.AdditionalContentAttributes);
                    this.getTags();
                })
            },
            saveSettings: function(obj) {
                this.$parent.saving = true;
                var payload = new Object();
                payload["WCMS_WebPageContent_ID"] = this.contentid;
                payload["AdditionalContentAttributes"] = '{"idForSection": ' + this.pickedTag + ', "default": ' + parseInt(this.settingsModule.default) + '}'
                axios.post(basedir + '/ajaxRequestServlet?mode=WebContentElement', JSON.stringify([payload]), {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }).then(response => {
                    axios.post(basedir + "/adminServlet?action=resetPageCache&WCMS_WebHost_ID=" + this.$root.webhost + "&WCMS_WebPage_ID=" + this.$root.pageid).then(reponse => {
                        this.$parent.settingsMode = false;
                        this.$parent.saving = false;
                        this.$emit('newSettings', {id:  parseInt(this.pickedTag), amount:this.settingsModule.default});
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    svg[data-prefix="fas"] {
        color: #75c791;
        min-width: 27px;
        margin-left: -5px;
        transition: all 0.3s ease-in-out;
    }
    button svg[data-prefix="fas"] {
        color: white !important;
        margin-left: 0;
        width: auto;
        min-width: unset;
    }
    svg.deactive {
        color: gray;
    }
    .tagGroupName {
        font-weight: bold;
        color: #74c791;
        margin-bottom: 0;
        margin-top: 10px;
    }
    .settingModule {
        background: #f9f9f9;
        width: auto;
        text-align: left;
        float: right;
        min-width: 255px;
        max-width: 241px;
        padding: 13px;
        transition: height 0.5s linear;
        border: 1px solid #00457042;
        border-radius: 5px;
        box-shadow: 0 0 8px #d2d2d2;
        em {
            color: #9a9a9a;
            font-size: 0.7em;
            	padding: 5px;
            margin-bottom: 10px;
            display: block;
        }
    }
    label[for="resultNo"] {
        padding-left: 4px;
    }
    .toggle {
        margin-bottom: 5px;
        label {
            max-width: 70%;
        }
    }
    label {
        display: inline-block;
        padding: 6px;
        margin-top: -1px;
    }
    input[type="text"],
    input[type="number"],
    input[type="email"] {
        float: right;
        border: 1px solid #cecece;
        &:focus {
            border: 1px solid #75c791;
        }
    }
    .vue-js-switch {
        float: right;
    }
    .saveRelationsBtn {
        width: 100%;
        cursor: pointer;
        margin-top: 20px;
        background: #75c791;
        border: 0;
        padding: 10px;
        color: white;
        font-weight: bold;
        text-transform: uppercase;
        &:disabled {
            &:hover {
                background: #bfcbd9;
            }
            background:#bfcbd9;
            cursor:not-allowed;
        }
        &:hover {
            background: #98e2b0;
        }
    }
    #resultNo {
        border-radius: 6px;
        padding: 6px;
        color: #75c791;
        font-weight: bold;
        text-align: center;
        width: 40px;
    }
    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        text-align: left;
        font-size: 1em;
        font-size: 1em;
        padding-left: 5px;
        margin: 0;
        cursor: pointer;
        width: 100%;
        margin-right: 32px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        &:hover {
            background: #74c7911a;
            border-radius: 7px;
        }
        /* Create a custom radio button */
        .checkmark {
            position: absolute;
            top: 5px;
            right: 8px;
            height: 20px;
            width: 20px;
            background-color: #eee;
            border-radius: 50%;
            border: 2px solid #a4b0bd;
            display: block;
            stroke-width: none;
            stroke: none;
            stroke-miterlimit: none;
            margin: 0;
            box-shadow: none;
            animation: none;
        }
        .checkbox {
            position: absolute;
            top: 5px;
            display: block;
            right: 8px;
            height: 20px;
            width: 20px;
            background-color: #eee;
            border-radius: 17%;
            border: 2px solid #a4b0bd;
            stroke-width: none;
            stroke: none;
            stroke-miterlimit: none;
            margin: 0;
            box-shadow: none;
            animation: none;
        }
    }
    /* Hide the browser's default radio button */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    /* On mouse-over, add a grey background color */
    .container:hover input~.checkmark,
    .container:hover input~.checkbox {
        background-color: #ccc;
    }
    /* When the radio button is checked, add a blue background */
    .container input:checked~.checkmark,
    .container input:checked~.checkbox {
        background-color: #75c791;
        border: 2px solid #75c791;
    }
    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after,
    .checkbox:after {
        content: "";
        position: absolute;
        display: none;
    }
    /* Show the indicator (dot/circle) when checked */
    .container input:checked~.checkmark:after,
    .container input:checked~.checkbox:after {
        display: block;
    }
    /* Style the indicator (dot/circle) */
    .container .checkmark:after,
    .container .checkbox:after {
        top: 6px;
        left: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0s ease;
    }
    .slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
</style>